"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterestShiftLength = void 0;
exports.instanceOfInterestShiftLength = instanceOfInterestShiftLength;
exports.InterestShiftLengthFromJSON = InterestShiftLengthFromJSON;
exports.InterestShiftLengthFromJSONTyped = InterestShiftLengthFromJSONTyped;
exports.InterestShiftLengthToJSON = InterestShiftLengthToJSON;
exports.InterestShiftLengthToJSONTyped = InterestShiftLengthToJSONTyped;
/**
 *
 * @export
 */
exports.InterestShiftLength = {
    EightHours: 'EIGHT_HOURS',
    TenHours: 'TEN_HOURS',
    TwelveHours: 'TWELVE_HOURS',
    Flexible: 'FLEXIBLE'
};
function instanceOfInterestShiftLength(value) {
    for (const key in exports.InterestShiftLength) {
        if (Object.prototype.hasOwnProperty.call(exports.InterestShiftLength, key)) {
            if (exports.InterestShiftLength[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function InterestShiftLengthFromJSON(json) {
    return InterestShiftLengthFromJSONTyped(json, false);
}
function InterestShiftLengthFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function InterestShiftLengthToJSON(value) {
    return value;
}
function InterestShiftLengthToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=InterestShiftLength.js.map